<script>

import { onMount } from "svelte";
import { formatCell, valueType } from '../Utils.js';

let { results } = $props();
let imgAttr = $state(null);
let imgHeight = $state('100%');

onMount(() => {
    results.results.bindings.every((node) => {
        let keys = Object.keys(node);
        imgHeight = 'calc(100% - (1rem * ' + (keys.length - 1) + '))';
        keys.every((key) => {
            if (valueType(node[key]) == 'image') {
                imgAttr = key;
                return false;
            }

            return true;
        });

        return imgAttr == null;
    });
});

</script>

<style>

.gallery {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 5px;

    .item {
        box-sizing: border-box;
        display: inline-block;
        padding: 1em;
        height: 30vh;
        flex-grow: 1;
        border: 1px solid #eee;

        img {
            width: 100%;
            object-fit: contain;
        }

        .summary {
            display: flex;
            flex-direction: column;
            max-width: 100%;
            margin: 0;
            padding: 0;

            p {
                height: 1rem;
            }
        }
    }
}

</style>

<div class="gallery">
    {#if imgAttr}
        {#each results.results.bindings as row}
            {#if Object.hasOwn(row, imgAttr)}
                <div class="item">
                    <a href={row[imgAttr].value} title="Link to Commons">
                        <img loading="lazy" src={row[imgAttr].value + '?width=1024'} style="height: {imgHeight}" alt="" />
                    </a>

                    <div class="summary">
                        {#each Object.keys(row) as attribute}
                            {#if attribute != imgAttr}
                                <p>
                                    {@html formatCell(row[attribute])}
                                </p>
                            {/if}
                        {/each}
                    </div>
                </div>
            {/if}
        {/each}
    {/if}
</div>
